import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import KitchenService from '../../api/services/KitchenService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';

const EditKitchen = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_KITCHENS_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [kitchenModal, setKitchenModal] = useState(false);
  const [file, setFile] = useState()
  const [kitchen, setKitchen] = useState([]);
  const [isLoading, setisloading] = useState(true);

  useEffect(() => {
    var id = params.id;
    getKitchenByID(id);
  }, []);


  const getKitchenByID = async (id) => {
    try {
      let kitchen = await KitchenService.show(id).json();
      setKitchen(kitchen.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title":event.target.de_title.value,
        "icon": file ? file.split(',')[1] : "",
        "description": event.target.description.value,
        "de_description":event.target.de_description.value,
      }
      let responseData = await KitchenService.update(params.id, userData).json()
      if (responseData.status === true) {
        setKitchenModal(true)
      }
    } catch (error) {

      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  return (
    <>
      <MainPagetitle mainTitle="Kitchen" pageTitle={'Kitchen'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Kitchen</h4>
              </div>

              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmit}>
                  <div className="row">
                    <h5 style={{ color: 'red' }}>{error}</h5>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          kitchen.title
                            ? kitchen.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder=""  defaultValue={
                          kitchen.de_title
                            ? kitchen.de_title
                            : ''
                        }/>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description' defaultValue={
                        kitchen.description
                          ? kitchen.description
                          : ''
                      } ></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description' defaultValue={
                        kitchen.de_description
                          ? kitchen.de_description
                          : ''
                      }></textarea>
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>
                      {kitchen.icon ? <img className="img-drop-area" height={100} width={100} name="icon" src={file ? file : imageUrl + kitchen.icon} alt='' /> : null}
                      <input type="file" className="form-control" name='icon' onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                    </div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={kitchenModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setKitchenModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Kitchen Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/kitchen'} variant="danger light" onClick={() => setKitchenModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditKitchen;